import { context } from "@core-ts/Contexts/Context"
import { CacheBase } from "./CacheBase"

type InstanceCacheKey = {
    userKey: string
    instance: string
}

// All entries in this cache is global over a specific instance
// This is likely the cache you want to use to cache session data per instance
export class InstanceCache<V, StateType = string> extends CacheBase<InstanceCacheKey, V, StateType> {
    constructor(name: string, timeoutSeconds: number | null = null, maximumCacheSize: number | null = null) {
        super("InstanceCache." + name, timeoutSeconds, maximumCacheSize)
    }
    async get(userKey: string, fn: () => Promise<V>, stateWhenValid: StateType | null = null, cacheTimeOverrideSeconds?: number): Promise<V> {
        const key = {
            userKey: userKey,
            instance: context.instance.instanceName
        }

        return this.internalGet(key, fn, stateWhenValid, cacheTimeOverrideSeconds)
    }
}
